'use client';
import { Button } from '@/shared/ui/Button';
import { FC } from 'react';
import { cvaButton, cvaRoot, cvaTitle } from './QaTabHeaderStyles';

interface Props {
  questionsCount: number;
}

const QaTabHeader: FC<Props> = ({ questionsCount }) => {
  return (
    <div className={cvaRoot()}>
      {questionsCount > 0 ? (
        <div className={cvaTitle()}>
          Не нашли подходящего <br />
          ответа?
        </div>
      ) : (
        <div className={cvaTitle()}>Вопросов о товаре пока нет</div>
      )}
      <Button
        className={cvaButton()}
        color={'mediumGreen'}
        size={'medium'}
        hoverEffect={'highlight'}
        href="https://mail.yandex.ru/?uid=1130000030983320&amp;login=pm#compose?to=info%40aloesmart.ru"
        target="_blank"
        prefetch={false}
      >
        Задать вопрос
      </Button>
    </div>
  );
};

export default QaTabHeader;
